// FeaturesSection.jsx
import { motion } from "framer-motion";
import { FaCogs, FaGem, FaPlay, FaRocket, FaUsers } from "react-icons/fa";
import "../css/FeaturesSection.css";

const features = [
  {
    id: 1,
    icon: <FaRocket />,
    title: "Personalized approach",
    desc: "Receive tailored financial solutions for your unique needs and goals.",
  },
  {
    id: 2,
    icon: <FaGem />,
    title: "Expert guidance",
    desc: "Benefit from the expertise of seasoned professionals with deep understanding.",
  },
  {
    id: 3,
    icon: <FaUsers />,
    title: "Client-centric focus",
    desc: "Enjoy exceptional service built on trust and long-term relationships.",
  },
  {
    id: 4,
    icon: <FaCogs />,
    title: "Comprehensive solutions",
    desc: "Access a wide range of services bundled under one investment.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="landing-techvision-feature-section">
      <div className="landing-techvision-feature-section-animated-bg"></div>

      <motion.div
        className="landing-techvision-feature-section-left"
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="landing-techvision-feature-section-grid">
          {features.map((item) => (
            <motion.div
              key={item.id}
              className="landing-techvision-feature-section-card landing-techvision-feature-section-glass-card"
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <div className="landing-techvision-feature-section-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        className="landing-techvision-feature-section-right"
        initial={{ opacity: 0, x: 60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h2>
          Choose us for your{" "}
          <span className="landing-techvision-feature-section-highlight">financial journey</span>
        </h2>
        <p>
          Our commitment is to provide you with modern, transparent, and reliable financial solutions
          that drive growth and success.
        </p>
        <motion.button
          className="landing-techvision-feature-section-demo-btn"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPlay className="landing-techvision-feature-section-play-icon" /> Watch Demo Video
        </motion.button>
      </motion.div>
    </section>
  );
};

export default FeaturesSection;
